"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.de_ListUserAssistantConversationsCommand = exports.de_ListAssistantMessagesCommand = exports.de_ListAssignmentAssistantsCommand = exports.de_GetAssistantMessageCommand = exports.de_GetAssistantConversationCommand = exports.de_GetAssistantCommand = exports.de_CreateAssistantMessageCommand = exports.de_CreateAssistantConversationCommand = exports.de_CreateAssistantCommand = exports.se_CreateSafeProgramCommand = exports.se_UpdatePearsonContextTemplateQuestionCommand = exports.se_UpdatePearsonContextTemplateCommand = exports.se_PutPearsonTemplateCommand = exports.se_PutPearsonQuestionCommand = exports.se_PutPearsonContextTemplateCommand = exports.se_PutPearsonBookCommand = exports.se_InstantiatePearsonTemplateCommand = exports.se_GetPearsonContextTemplateQuestionCommand = exports.se_GetPearsonContextTemplateCommand = exports.se_PutEditorFileCommand = exports.se_ListEditorSessionsCommand = exports.se_ListEditorDocumentsCommand = exports.se_ListEditorDocumentJupyterCellOutputsCommand = exports.se_InterruptEditorDocumentJupyterKernelCommand = exports.se_HandInEditorSessionCommand = exports.se_GetEditorSessionCommand = exports.se_GetEditorFileDownloadLinkCommand = exports.se_GetEditorDocumentCommand = exports.se_ExecuteEditorDocumentJupyterCellCommand = exports.se_CreateEditorSessionCommand = exports.se_UpdateAutoTestConfigurationCommand = exports.se_PutAutoTestConfigurationCommand = exports.se_ListAutoTestSnapshotsCommand = exports.se_GetAutoTestSnapshotCommand = exports.se_GetAutoTestPublishedSnapshotCommand = exports.se_GetAutoTestConfigurationCommand = exports.se_DeleteAutoTestConfigurationCommand = exports.se_CreateAutoTestSnapshotCommand = exports.se_CopyAutoTestConfigurationCommand = exports.se_CompleteImportAutoTestConfigurationCommand = exports.se_UpdateAssistantCommand = exports.se_ListUserAssistantConversationsCommand = exports.se_ListAssistantMessagesCommand = exports.se_ListAssignmentAssistantsCommand = exports.se_GetAssistantMessageCommand = exports.se_GetAssistantConversationCommand = exports.se_GetAssistantCommand = exports.se_CreateAssistantMessageCommand = exports.se_CreateAssistantConversationCommand = exports.se_CreateAssistantCommand = void 0;
exports.de_CreateSafeProgramCommand = exports.de_UpdatePearsonContextTemplateQuestionCommand = exports.de_UpdatePearsonContextTemplateCommand = exports.de_PutPearsonTemplateCommand = exports.de_PutPearsonQuestionCommand = exports.de_PutPearsonContextTemplateCommand = exports.de_PutPearsonBookCommand = exports.de_InstantiatePearsonTemplateCommand = exports.de_GetPearsonContextTemplateQuestionCommand = exports.de_GetPearsonContextTemplateCommand = exports.de_PutEditorFileCommand = exports.de_ListEditorSessionsCommand = exports.de_ListEditorDocumentsCommand = exports.de_ListEditorDocumentJupyterCellOutputsCommand = exports.de_InterruptEditorDocumentJupyterKernelCommand = exports.de_HandInEditorSessionCommand = exports.de_GetEditorSessionCommand = exports.de_GetEditorFileDownloadLinkCommand = exports.de_GetEditorDocumentCommand = exports.de_ExecuteEditorDocumentJupyterCellCommand = exports.de_CreateEditorSessionCommand = exports.de_UpdateAutoTestConfigurationCommand = exports.de_PutAutoTestConfigurationCommand = exports.de_ListAutoTestSnapshotsCommand = exports.de_GetAutoTestSnapshotCommand = exports.de_GetAutoTestPublishedSnapshotCommand = exports.de_GetAutoTestConfigurationCommand = exports.de_DeleteAutoTestConfigurationCommand = exports.de_CreateAutoTestSnapshotCommand = exports.de_CopyAutoTestConfigurationCommand = exports.de_CompleteImportAutoTestConfigurationCommand = exports.de_UpdateAssistantCommand = void 0;
const Apiv2ServiceException_1 = require("../models/Apiv2ServiceException");
const models_0_1 = require("../models/models_0");
const models_1_1 = require("../models/models_1");
const core_1 = require("@aws-sdk/core");
const core_2 = require("@smithy/core");
const smithy_client_1 = require("@smithy/smithy-client");
const se_CreateAssistantCommand = async (input, context) => {
    const b = (0, core_2.requestBuilder)(input, context);
    const headers = {
        'content-type': 'application/json',
    };
    b.bp("/assistants");
    let body;
    body = JSON.stringify((0, smithy_client_1.take)(input, {
        'data': _ => (0, smithy_client_1._json)(_),
        'features': _ => (0, smithy_client_1._json)(_),
        'name': [],
        'status': _ => (0, smithy_client_1._json)(_),
        'systemPrompt': [],
    }));
    b.m("POST")
        .h(headers)
        .b(body);
    return b.build();
};
exports.se_CreateAssistantCommand = se_CreateAssistantCommand;
const se_CreateAssistantConversationCommand = async (input, context) => {
    const b = (0, core_2.requestBuilder)(input, context);
    const headers = {
        'content-type': 'application/json',
    };
    b.bp("/assistants/{assistantId}/conversations");
    b.p('assistantId', () => input.assistantId, '{assistantId}', false);
    let body;
    body = JSON.stringify((0, smithy_client_1.take)(input, {
        'context': _ => (0, smithy_client_1._json)(_),
        'initialMessage': _ => (0, smithy_client_1._json)(_),
        'owner': [],
        'title': [],
    }));
    b.m("POST")
        .h(headers)
        .b(body);
    return b.build();
};
exports.se_CreateAssistantConversationCommand = se_CreateAssistantConversationCommand;
const se_CreateAssistantMessageCommand = async (input, context) => {
    const b = (0, core_2.requestBuilder)(input, context);
    const headers = {
        'content-type': 'application/json',
    };
    b.bp("/assistants/{assistantId}/conversations/{conversationId}/messages");
    b.p('assistantId', () => input.assistantId, '{assistantId}', false);
    b.p('conversationId', () => input.conversationId, '{conversationId}', false);
    let body;
    body = JSON.stringify((0, smithy_client_1.take)(input, {
        'content': _ => (0, smithy_client_1._json)(_),
        'context': _ => (0, smithy_client_1._json)(_),
    }));
    b.m("POST")
        .h(headers)
        .b(body);
    return b.build();
};
exports.se_CreateAssistantMessageCommand = se_CreateAssistantMessageCommand;
const se_GetAssistantCommand = async (input, context) => {
    const b = (0, core_2.requestBuilder)(input, context);
    const headers = {};
    b.bp("/assistants/{assistantId}");
    b.p('assistantId', () => input.assistantId, '{assistantId}', false);
    let body;
    b.m("GET")
        .h(headers)
        .b(body);
    return b.build();
};
exports.se_GetAssistantCommand = se_GetAssistantCommand;
const se_GetAssistantConversationCommand = async (input, context) => {
    const b = (0, core_2.requestBuilder)(input, context);
    const headers = {};
    b.bp("/assistants/{assistantId}/conversations/{conversationId}");
    b.p('assistantId', () => input.assistantId, '{assistantId}', false);
    b.p('conversationId', () => input.conversationId, '{conversationId}', false);
    let body;
    b.m("GET")
        .h(headers)
        .b(body);
    return b.build();
};
exports.se_GetAssistantConversationCommand = se_GetAssistantConversationCommand;
const se_GetAssistantMessageCommand = async (input, context) => {
    const b = (0, core_2.requestBuilder)(input, context);
    const headers = {};
    b.bp("/assistants/{assistantId}/conversations/{conversationId}/messages/{messageId}");
    b.p('assistantId', () => input.assistantId, '{assistantId}', false);
    b.p('conversationId', () => input.conversationId, '{conversationId}', false);
    b.p('messageId', () => input.messageId, '{messageId}', false);
    let body;
    b.m("GET")
        .h(headers)
        .b(body);
    return b.build();
};
exports.se_GetAssistantMessageCommand = se_GetAssistantMessageCommand;
const se_ListAssignmentAssistantsCommand = async (input, context) => {
    const b = (0, core_2.requestBuilder)(input, context);
    const headers = (0, smithy_client_1.map)({}, smithy_client_1.isSerializableHeaderValue, {
        [_xnt]: input[_nT],
        [_xps]: [() => (0, smithy_client_1.isSerializableHeaderValue)(input[_pS]), () => input[_pS].toString()],
    });
    b.bp("/assignments/{assignmentId}/assistants");
    b.p('assignmentId', () => input.assignmentId, '{assignmentId}', false);
    let body;
    b.m("GET")
        .h(headers)
        .b(body);
    return b.build();
};
exports.se_ListAssignmentAssistantsCommand = se_ListAssignmentAssistantsCommand;
const se_ListAssistantMessagesCommand = async (input, context) => {
    const b = (0, core_2.requestBuilder)(input, context);
    const headers = (0, smithy_client_1.map)({}, smithy_client_1.isSerializableHeaderValue, {
        [_xnt]: input[_nT],
        [_xps]: [() => (0, smithy_client_1.isSerializableHeaderValue)(input[_pS]), () => input[_pS].toString()],
    });
    b.bp("/assistantId/{assistantId}/conversations/{conversationId}/messages");
    b.p('assistantId', () => input.assistantId, '{assistantId}', false);
    b.p('conversationId', () => input.conversationId, '{conversationId}', false);
    let body;
    b.m("GET")
        .h(headers)
        .b(body);
    return b.build();
};
exports.se_ListAssistantMessagesCommand = se_ListAssistantMessagesCommand;
const se_ListUserAssistantConversationsCommand = async (input, context) => {
    const b = (0, core_2.requestBuilder)(input, context);
    const headers = (0, smithy_client_1.map)({}, smithy_client_1.isSerializableHeaderValue, {
        [_xnt]: input[_nT],
        [_xps]: [() => (0, smithy_client_1.isSerializableHeaderValue)(input[_pS]), () => input[_pS].toString()],
    });
    b.bp("/users/{userId}/conversations");
    b.p('userId', () => input.userId, '{userId}', false);
    const query = (0, smithy_client_1.map)({
        [_aI]: [, (0, smithy_client_1.expectNonNull)(input[_aI], `assignmentId`)],
    });
    let body;
    b.m("GET")
        .h(headers)
        .q(query)
        .b(body);
    return b.build();
};
exports.se_ListUserAssistantConversationsCommand = se_ListUserAssistantConversationsCommand;
const se_UpdateAssistantCommand = async (input, context) => {
    const b = (0, core_2.requestBuilder)(input, context);
    const headers = {
        'content-type': 'application/json',
    };
    b.bp("/assistants/{assistantId}");
    b.p('assistantId', () => input.assistantId, '{assistantId}', false);
    let body;
    body = JSON.stringify((0, smithy_client_1.take)(input, {
        'features': _ => (0, smithy_client_1._json)(_),
        'name': [],
        'status': _ => (0, smithy_client_1._json)(_),
        'systemPrompt': [],
    }));
    b.m("PATCH")
        .h(headers)
        .b(body);
    return b.build();
};
exports.se_UpdateAssistantCommand = se_UpdateAssistantCommand;
const se_CompleteImportAutoTestConfigurationCommand = async (input, context) => {
    const b = (0, core_2.requestBuilder)(input, context);
    const headers = {
        'content-type': 'application/json',
    };
    b.bp("/autotest/{assignmentId}/complete-import");
    b.p('assignmentId', () => input.assignmentId, '{assignmentId}', false);
    let body;
    body = JSON.stringify((0, smithy_client_1.take)(input, {
        'dstAssignmentId': [],
        'rubricConfiguration': _ => (0, smithy_client_1._json)(_),
    }));
    b.m("POST")
        .h(headers)
        .b(body);
    return b.build();
};
exports.se_CompleteImportAutoTestConfigurationCommand = se_CompleteImportAutoTestConfigurationCommand;
const se_CopyAutoTestConfigurationCommand = async (input, context) => {
    const b = (0, core_2.requestBuilder)(input, context);
    const headers = {
        'content-type': 'application/json',
    };
    b.bp("/autotest/{assignmentId}/copy");
    b.p('assignmentId', () => input.assignmentId, '{assignmentId}', false);
    let body;
    body = JSON.stringify((0, smithy_client_1.take)(input, {
        'dstAssignmentId': [],
        'overwriteRubric': _ => (0, smithy_client_1._json)(_),
    }));
    b.m("POST")
        .h(headers)
        .b(body);
    return b.build();
};
exports.se_CopyAutoTestConfigurationCommand = se_CopyAutoTestConfigurationCommand;
const se_CreateAutoTestSnapshotCommand = async (input, context) => {
    const b = (0, core_2.requestBuilder)(input, context);
    const headers = {};
    b.bp("/autotest/{assignmentId}/snapshots");
    b.p('assignmentId', () => input.assignmentId, '{assignmentId}', false);
    let body;
    b.m("POST")
        .h(headers)
        .b(body);
    return b.build();
};
exports.se_CreateAutoTestSnapshotCommand = se_CreateAutoTestSnapshotCommand;
const se_DeleteAutoTestConfigurationCommand = async (input, context) => {
    const b = (0, core_2.requestBuilder)(input, context);
    const headers = {};
    b.bp("/autotest/{assignmentId}");
    b.p('assignmentId', () => input.assignmentId, '{assignmentId}', false);
    let body;
    b.m("DELETE")
        .h(headers)
        .b(body);
    return b.build();
};
exports.se_DeleteAutoTestConfigurationCommand = se_DeleteAutoTestConfigurationCommand;
const se_GetAutoTestConfigurationCommand = async (input, context) => {
    const b = (0, core_2.requestBuilder)(input, context);
    const headers = {};
    b.bp("/autotest/{assignmentId}");
    b.p('assignmentId', () => input.assignmentId, '{assignmentId}', false);
    let body;
    b.m("GET")
        .h(headers)
        .b(body);
    return b.build();
};
exports.se_GetAutoTestConfigurationCommand = se_GetAutoTestConfigurationCommand;
const se_GetAutoTestPublishedSnapshotCommand = async (input, context) => {
    const b = (0, core_2.requestBuilder)(input, context);
    const headers = {};
    b.bp("/autotest/{assignmentId}/published-snapshot");
    b.p('assignmentId', () => input.assignmentId, '{assignmentId}', false);
    let body;
    b.m("GET")
        .h(headers)
        .b(body);
    return b.build();
};
exports.se_GetAutoTestPublishedSnapshotCommand = se_GetAutoTestPublishedSnapshotCommand;
const se_GetAutoTestSnapshotCommand = async (input, context) => {
    const b = (0, core_2.requestBuilder)(input, context);
    const headers = {};
    b.bp("/autotest/{assignmentId}/snapshots/{snapshotId}");
    b.p('assignmentId', () => input.assignmentId, '{assignmentId}', false);
    b.p('snapshotId', () => input.snapshotId, '{snapshotId}', false);
    let body;
    b.m("GET")
        .h(headers)
        .b(body);
    return b.build();
};
exports.se_GetAutoTestSnapshotCommand = se_GetAutoTestSnapshotCommand;
const se_ListAutoTestSnapshotsCommand = async (input, context) => {
    const b = (0, core_2.requestBuilder)(input, context);
    const headers = (0, smithy_client_1.map)({}, smithy_client_1.isSerializableHeaderValue, {
        [_xnt]: input[_nT],
        [_xps]: [() => (0, smithy_client_1.isSerializableHeaderValue)(input[_pS]), () => input[_pS].toString()],
    });
    b.bp("/autotest/{assignmentId}/snapshots");
    b.p('assignmentId', () => input.assignmentId, '{assignmentId}', false);
    let body;
    b.m("GET")
        .h(headers)
        .b(body);
    return b.build();
};
exports.se_ListAutoTestSnapshotsCommand = se_ListAutoTestSnapshotsCommand;
const se_PutAutoTestConfigurationCommand = async (input, context) => {
    const b = (0, core_2.requestBuilder)(input, context);
    const headers = {};
    b.bp("/autotest/{assignmentId}");
    b.p('assignmentId', () => input.assignmentId, '{assignmentId}', false);
    let body;
    b.m("PUT")
        .h(headers)
        .b(body);
    return b.build();
};
exports.se_PutAutoTestConfigurationCommand = se_PutAutoTestConfigurationCommand;
const se_UpdateAutoTestConfigurationCommand = async (input, context) => {
    const b = (0, core_2.requestBuilder)(input, context);
    const headers = {
        'content-type': 'application/json',
    };
    b.bp("/autotest/{assignmentId}");
    b.p('assignmentId', () => input.assignmentId, '{assignmentId}', false);
    let body;
    body = JSON.stringify((0, smithy_client_1.take)(input, {
        'publishedSnapshot': _ => (0, smithy_client_1._json)(_),
        'updatedSetup': _ => se_AutoTestSetupConfigurationInput(_, context),
        'updatedTest': _ => se_AutoTestTestConfigurationInput(_, context),
    }));
    b.m("PATCH")
        .h(headers)
        .b(body);
    return b.build();
};
exports.se_UpdateAutoTestConfigurationCommand = se_UpdateAutoTestConfigurationCommand;
const se_CreateEditorSessionCommand = async (input, context) => {
    const b = (0, core_2.requestBuilder)(input, context);
    const headers = {
        'content-type': 'application/json',
    };
    b.bp("/editor-sessions");
    let body;
    body = JSON.stringify((0, smithy_client_1.take)(input, {
        'assignmentId': [],
        'name': [],
        'owner': [],
        'source': _ => (0, smithy_client_1._json)(_),
    }));
    b.m("POST")
        .h(headers)
        .b(body);
    return b.build();
};
exports.se_CreateEditorSessionCommand = se_CreateEditorSessionCommand;
const se_ExecuteEditorDocumentJupyterCellCommand = async (input, context) => {
    const b = (0, core_2.requestBuilder)(input, context);
    const headers = {
        'content-type': 'text/plain',
    };
    b.bp("/editor-documents/{documentId}/jupyter-cells/{cellId}/execute");
    b.p('documentId', () => input.documentId, '{documentId}', false);
    b.p('cellId', () => input.cellId, '{cellId}', false);
    let body;
    if (input.code !== undefined) {
        body = input.code;
    }
    b.m("POST")
        .h(headers)
        .b(body);
    return b.build();
};
exports.se_ExecuteEditorDocumentJupyterCellCommand = se_ExecuteEditorDocumentJupyterCellCommand;
const se_GetEditorDocumentCommand = async (input, context) => {
    const b = (0, core_2.requestBuilder)(input, context);
    const headers = {};
    b.bp("/editor-documents/{documentId}");
    b.p('documentId', () => input.documentId, '{documentId}', false);
    let body;
    b.m("GET")
        .h(headers)
        .b(body);
    return b.build();
};
exports.se_GetEditorDocumentCommand = se_GetEditorDocumentCommand;
const se_GetEditorFileDownloadLinkCommand = async (input, context) => {
    const b = (0, core_2.requestBuilder)(input, context);
    const headers = {};
    b.bp("/editor-sessions/{editorSessionId}/file");
    b.p('editorSessionId', () => input.editorSessionId, '{editorSessionId}', false);
    const query = (0, smithy_client_1.map)({
        [_p]: [, (0, smithy_client_1.expectNonNull)(input[_p], `path`)],
    });
    let body;
    b.m("GET")
        .h(headers)
        .q(query)
        .b(body);
    return b.build();
};
exports.se_GetEditorFileDownloadLinkCommand = se_GetEditorFileDownloadLinkCommand;
const se_GetEditorSessionCommand = async (input, context) => {
    const b = (0, core_2.requestBuilder)(input, context);
    const headers = {};
    b.bp("/editor-sessions/{editorSessionId}");
    b.p('editorSessionId', () => input.editorSessionId, '{editorSessionId}', false);
    let body;
    b.m("GET")
        .h(headers)
        .b(body);
    return b.build();
};
exports.se_GetEditorSessionCommand = se_GetEditorSessionCommand;
const se_HandInEditorSessionCommand = async (input, context) => {
    const b = (0, core_2.requestBuilder)(input, context);
    const headers = {
        'content-type': 'application/json',
    };
    b.bp("/editors-sessions/{editorSessionId}/hand-in");
    b.p('editorSessionId', () => input.editorSessionId, '{editorSessionId}', false);
    let body;
    body = JSON.stringify((0, smithy_client_1.take)(input, {
        'ignoreNonInteractedQuestions': [],
    }));
    b.m("POST")
        .h(headers)
        .b(body);
    return b.build();
};
exports.se_HandInEditorSessionCommand = se_HandInEditorSessionCommand;
const se_InterruptEditorDocumentJupyterKernelCommand = async (input, context) => {
    const b = (0, core_2.requestBuilder)(input, context);
    const headers = {};
    b.bp("/editor-documents/{documentId}/interrupt");
    b.p('documentId', () => input.documentId, '{documentId}', false);
    let body;
    b.m("POST")
        .h(headers)
        .b(body);
    return b.build();
};
exports.se_InterruptEditorDocumentJupyterKernelCommand = se_InterruptEditorDocumentJupyterKernelCommand;
const se_ListEditorDocumentJupyterCellOutputsCommand = async (input, context) => {
    const b = (0, core_2.requestBuilder)(input, context);
    const headers = (0, smithy_client_1.map)({}, smithy_client_1.isSerializableHeaderValue, {
        [_xnt]: input[_nT],
        [_xps]: [() => (0, smithy_client_1.isSerializableHeaderValue)(input[_pS]), () => input[_pS].toString()],
    });
    b.bp("/editor-documents/{documentId}/jupyter-cells/{cellId}/outputs");
    b.p('documentId', () => input.documentId, '{documentId}', false);
    b.p('cellId', () => input.cellId, '{cellId}', false);
    let body;
    b.m("GET")
        .h(headers)
        .b(body);
    return b.build();
};
exports.se_ListEditorDocumentJupyterCellOutputsCommand = se_ListEditorDocumentJupyterCellOutputsCommand;
const se_ListEditorDocumentsCommand = async (input, context) => {
    const b = (0, core_2.requestBuilder)(input, context);
    const headers = (0, smithy_client_1.map)({}, smithy_client_1.isSerializableHeaderValue, {
        [_xnt]: input[_nT],
        [_xps]: [() => (0, smithy_client_1.isSerializableHeaderValue)(input[_pS]), () => input[_pS].toString()],
    });
    b.bp("/editor-sessions/{editorSessionId}/documents");
    b.p('editorSessionId', () => input.editorSessionId, '{editorSessionId}', false);
    let body;
    b.m("GET")
        .h(headers)
        .b(body);
    return b.build();
};
exports.se_ListEditorDocumentsCommand = se_ListEditorDocumentsCommand;
const se_ListEditorSessionsCommand = async (input, context) => {
    const b = (0, core_2.requestBuilder)(input, context);
    const headers = (0, smithy_client_1.map)({}, smithy_client_1.isSerializableHeaderValue, {
        [_xnt]: input[_nT],
        [_xps]: [() => (0, smithy_client_1.isSerializableHeaderValue)(input[_pS]), () => input[_pS].toString()],
    });
    b.bp("/users/{userId}/editor-sessions");
    b.p('userId', () => input.userId, '{userId}', false);
    const query = (0, smithy_client_1.map)({
        [_aI]: [, (0, smithy_client_1.expectNonNull)(input[_aI], `assignmentId`)],
    });
    let body;
    b.m("GET")
        .h(headers)
        .q(query)
        .b(body);
    return b.build();
};
exports.se_ListEditorSessionsCommand = se_ListEditorSessionsCommand;
const se_PutEditorFileCommand = async (input, context) => {
    const b = (0, core_2.requestBuilder)(input, context);
    const headers = {
        'content-type': 'application/json',
    };
    b.bp("/editor-sessions/{editorSessionId}/files");
    b.p('editorSessionId', () => input.editorSessionId, '{editorSessionId}', false);
    let body;
    body = JSON.stringify((0, smithy_client_1.take)(input, {
        'fileType': _ => (0, smithy_client_1._json)(_),
        'path': [],
    }));
    b.m("PUT")
        .h(headers)
        .b(body);
    return b.build();
};
exports.se_PutEditorFileCommand = se_PutEditorFileCommand;
const se_GetPearsonContextTemplateCommand = async (input, context) => {
    const b = (0, core_2.requestBuilder)(input, context);
    const headers = {};
    b.bp("/tenants/{tenantId}/pearson-templates/{templateId}/courses/{contextId}");
    b.p('tenantId', () => input.tenantId, '{tenantId}', false);
    b.p('templateId', () => input.templateId, '{templateId}', false);
    b.p('contextId', () => input.contextId, '{contextId}', false);
    let body;
    b.m("GET")
        .h(headers)
        .b(body);
    return b.build();
};
exports.se_GetPearsonContextTemplateCommand = se_GetPearsonContextTemplateCommand;
const se_GetPearsonContextTemplateQuestionCommand = async (input, context) => {
    const b = (0, core_2.requestBuilder)(input, context);
    const headers = {};
    b.bp("/tenants/{tenantId}/pearson-templates/{templateId}/context/{contextId}/questions/{questionId}");
    b.p('tenantId', () => input.tenantId, '{tenantId}', false);
    b.p('templateId', () => input.templateId, '{templateId}', false);
    b.p('contextId', () => input.contextId, '{contextId}', false);
    b.p('questionId', () => input.questionId, '{questionId}', false);
    let body;
    b.m("GET")
        .h(headers)
        .b(body);
    return b.build();
};
exports.se_GetPearsonContextTemplateQuestionCommand = se_GetPearsonContextTemplateQuestionCommand;
const se_InstantiatePearsonTemplateCommand = async (input, context) => {
    const b = (0, core_2.requestBuilder)(input, context);
    const headers = {
        'content-type': 'application/json',
    };
    b.bp("/tenants/{tenantId}/pearson-templates/{templateId}/instantiate");
    b.p('tenantId', () => input.tenantId, '{tenantId}', false);
    b.p('templateId', () => input.templateId, '{templateId}', false);
    let body;
    body = JSON.stringify((0, smithy_client_1.take)(input, {
        'dstAssignmentId': [],
        'questionsMapping': _ => (0, smithy_client_1._json)(_),
    }));
    b.m("PUT")
        .h(headers)
        .b(body);
    return b.build();
};
exports.se_InstantiatePearsonTemplateCommand = se_InstantiatePearsonTemplateCommand;
const se_PutPearsonBookCommand = async (input, context) => {
    const b = (0, core_2.requestBuilder)(input, context);
    const headers = {
        'content-type': 'application/json',
    };
    b.bp("/tenants/{tenantId}/pearson-books/{bookId}");
    b.p('tenantId', () => input.tenantId, '{tenantId}', false);
    b.p('bookId', () => input.bookId, '{bookId}', false);
    let body;
    body = JSON.stringify((0, smithy_client_1.take)(input, {
        'author': [],
        'buildAssignmentId': [],
        'language': [],
        'tags': _ => (0, smithy_client_1._json)(_),
        'year': [],
    }));
    b.m("PUT")
        .h(headers)
        .b(body);
    return b.build();
};
exports.se_PutPearsonBookCommand = se_PutPearsonBookCommand;
const se_PutPearsonContextTemplateCommand = async (input, context) => {
    const b = (0, core_2.requestBuilder)(input, context);
    const headers = {};
    b.bp("/tenants/{tenantId}/pearson-templates/{templateId}/courses/{contextId}");
    b.p('tenantId', () => input.tenantId, '{tenantId}', false);
    b.p('templateId', () => input.templateId, '{templateId}', false);
    b.p('contextId', () => input.contextId, '{contextId}', false);
    let body;
    b.m("PUT")
        .h(headers)
        .b(body);
    return b.build();
};
exports.se_PutPearsonContextTemplateCommand = se_PutPearsonContextTemplateCommand;
const se_PutPearsonQuestionCommand = async (input, context) => {
    const b = (0, core_2.requestBuilder)(input, context);
    const headers = {
        'content-type': 'application/json',
    };
    b.bp("/tenants/{tenantId}/pearson-templates/{templateId}/questions/{questionId}");
    b.p('tenantId', () => input.tenantId, '{tenantId}', false);
    b.p('templateId', () => input.templateId, '{templateId}', false);
    b.p('questionId', () => input.questionId, '{questionId}', false);
    let body;
    body = JSON.stringify((0, smithy_client_1.take)(input, {
        'name': [],
        'source': _ => (0, smithy_client_1._json)(_),
    }));
    b.m("PUT")
        .h(headers)
        .b(body);
    return b.build();
};
exports.se_PutPearsonQuestionCommand = se_PutPearsonQuestionCommand;
const se_PutPearsonTemplateCommand = async (input, context) => {
    const b = (0, core_2.requestBuilder)(input, context);
    const headers = {
        'content-type': 'application/json',
    };
    b.bp("/tenants/{tenantId}/pearson-templates/{templateId}");
    b.p('tenantId', () => input.tenantId, '{tenantId}', false);
    b.p('templateId', () => input.templateId, '{templateId}', false);
    let body;
    body = JSON.stringify((0, smithy_client_1.take)(input, {
        'bookId': [],
        'name': [],
        'runSingleQuestions': [],
        'viewMode': [],
    }));
    b.m("PUT")
        .h(headers)
        .b(body);
    return b.build();
};
exports.se_PutPearsonTemplateCommand = se_PutPearsonTemplateCommand;
const se_UpdatePearsonContextTemplateCommand = async (input, context) => {
    const b = (0, core_2.requestBuilder)(input, context);
    const headers = {
        'content-type': 'application/json',
    };
    b.bp("/tenants/{tenantId}/pearson-templates/{templateId}/context/{contextId}");
    b.p('tenantId', () => input.tenantId, '{tenantId}', false);
    b.p('templateId', () => input.templateId, '{templateId}', false);
    b.p('contextId', () => input.contextId, '{contextId}', false);
    let body;
    body = JSON.stringify((0, smithy_client_1.take)(input, {
        'numberOfAttempts': _ => (0, smithy_client_1._json)(_),
    }));
    b.m("PATCH")
        .h(headers)
        .b(body);
    return b.build();
};
exports.se_UpdatePearsonContextTemplateCommand = se_UpdatePearsonContextTemplateCommand;
const se_UpdatePearsonContextTemplateQuestionCommand = async (input, context) => {
    const b = (0, core_2.requestBuilder)(input, context);
    const headers = {
        'content-type': 'application/json',
    };
    b.bp("/tenants/{tenantId}/pearson-templates/{templateId}/context/{contextId}/questions/{questionId}");
    b.p('tenantId', () => input.tenantId, '{tenantId}', false);
    b.p('templateId', () => input.templateId, '{templateId}', false);
    b.p('contextId', () => input.contextId, '{contextId}', false);
    b.p('questionId', () => input.questionId, '{questionId}', false);
    let body;
    body = JSON.stringify((0, smithy_client_1.take)(input, {
        'enabled': [],
    }));
    b.m("PATCH")
        .h(headers)
        .b(body);
    return b.build();
};
exports.se_UpdatePearsonContextTemplateQuestionCommand = se_UpdatePearsonContextTemplateQuestionCommand;
const se_CreateSafeProgramCommand = async (input, context) => {
    const b = (0, core_2.requestBuilder)(input, context);
    const headers = {
        'content-type': 'application/json',
    };
    b.bp("/safe-program");
    let body;
    body = JSON.stringify((0, smithy_client_1.take)(input, {
        'source': _ => (0, smithy_client_1._json)(_),
    }));
    b.m("POST")
        .h(headers)
        .b(body);
    return b.build();
};
exports.se_CreateSafeProgramCommand = se_CreateSafeProgramCommand;
const de_CreateAssistantCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = (0, smithy_client_1.map)({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectObject)(await (0, core_1.parseJsonBody)(output.body, context));
    contents.assistant = (0, smithy_client_1._json)(data);
    return contents;
};
exports.de_CreateAssistantCommand = de_CreateAssistantCommand;
const de_CreateAssistantConversationCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = (0, smithy_client_1.map)({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectObject)(await (0, core_1.parseJsonBody)(output.body, context));
    contents.conversation = de_AssistantConversation(data, context);
    return contents;
};
exports.de_CreateAssistantConversationCommand = de_CreateAssistantConversationCommand;
const de_CreateAssistantMessageCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = (0, smithy_client_1.map)({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectObject)(await (0, core_1.parseJsonBody)(output.body, context));
    contents.message = de_AssistantMessage(data, context);
    return contents;
};
exports.de_CreateAssistantMessageCommand = de_CreateAssistantMessageCommand;
const de_GetAssistantCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = (0, smithy_client_1.map)({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectObject)(await (0, core_1.parseJsonBody)(output.body, context));
    contents.assistant = (0, smithy_client_1._json)(data);
    return contents;
};
exports.de_GetAssistantCommand = de_GetAssistantCommand;
const de_GetAssistantConversationCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = (0, smithy_client_1.map)({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectObject)(await (0, core_1.parseJsonBody)(output.body, context));
    contents.conversation = de_AssistantConversation(data, context);
    return contents;
};
exports.de_GetAssistantConversationCommand = de_GetAssistantConversationCommand;
const de_GetAssistantMessageCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = (0, smithy_client_1.map)({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectObject)(await (0, core_1.parseJsonBody)(output.body, context));
    contents.message = de_AssistantMessage(data, context);
    return contents;
};
exports.de_GetAssistantMessageCommand = de_GetAssistantMessageCommand;
const de_ListAssignmentAssistantsCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = (0, smithy_client_1.map)({
        $metadata: deserializeMetadata(output),
        [_nT]: [, output.headers[_xnt]],
    });
    const data = (0, smithy_client_1.expectNonNull)(((0, smithy_client_1.expectObject)(await (0, core_1.parseJsonBody)(output.body, context))), "body");
    const doc = (0, smithy_client_1.take)(data, {
        'assistants': smithy_client_1._json,
    });
    Object.assign(contents, doc);
    return contents;
};
exports.de_ListAssignmentAssistantsCommand = de_ListAssignmentAssistantsCommand;
const de_ListAssistantMessagesCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = (0, smithy_client_1.map)({
        $metadata: deserializeMetadata(output),
        [_nT]: [, output.headers[_xnt]],
    });
    const data = (0, smithy_client_1.expectNonNull)(((0, smithy_client_1.expectObject)(await (0, core_1.parseJsonBody)(output.body, context))), "body");
    const doc = (0, smithy_client_1.take)(data, {
        'messages': _ => de_AssistantMessages(_, context),
    });
    Object.assign(contents, doc);
    return contents;
};
exports.de_ListAssistantMessagesCommand = de_ListAssistantMessagesCommand;
const de_ListUserAssistantConversationsCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = (0, smithy_client_1.map)({
        $metadata: deserializeMetadata(output),
        [_nT]: [, output.headers[_xnt]],
    });
    const data = (0, smithy_client_1.expectNonNull)(((0, smithy_client_1.expectObject)(await (0, core_1.parseJsonBody)(output.body, context))), "body");
    const doc = (0, smithy_client_1.take)(data, {
        'conversations': _ => de_AssistantConversations(_, context),
    });
    Object.assign(contents, doc);
    return contents;
};
exports.de_ListUserAssistantConversationsCommand = de_ListUserAssistantConversationsCommand;
const de_UpdateAssistantCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = (0, smithy_client_1.map)({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectObject)(await (0, core_1.parseJsonBody)(output.body, context));
    contents.assistant = (0, smithy_client_1._json)(data);
    return contents;
};
exports.de_UpdateAssistantCommand = de_UpdateAssistantCommand;
const de_CompleteImportAutoTestConfigurationCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = (0, smithy_client_1.map)({
        $metadata: deserializeMetadata(output),
    });
    await (0, smithy_client_1.collectBody)(output.body, context);
    return contents;
};
exports.de_CompleteImportAutoTestConfigurationCommand = de_CompleteImportAutoTestConfigurationCommand;
const de_CopyAutoTestConfigurationCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = (0, smithy_client_1.map)({
        $metadata: deserializeMetadata(output),
    });
    await (0, smithy_client_1.collectBody)(output.body, context);
    return contents;
};
exports.de_CopyAutoTestConfigurationCommand = de_CopyAutoTestConfigurationCommand;
const de_CreateAutoTestSnapshotCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = (0, smithy_client_1.map)({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectObject)(await (0, core_1.parseJsonBody)(output.body, context));
    contents.snapshot = de_AutoTestSnapshotSummary(data, context);
    return contents;
};
exports.de_CreateAutoTestSnapshotCommand = de_CreateAutoTestSnapshotCommand;
const de_DeleteAutoTestConfigurationCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = (0, smithy_client_1.map)({
        $metadata: deserializeMetadata(output),
    });
    await (0, smithy_client_1.collectBody)(output.body, context);
    return contents;
};
exports.de_DeleteAutoTestConfigurationCommand = de_DeleteAutoTestConfigurationCommand;
const de_GetAutoTestConfigurationCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = (0, smithy_client_1.map)({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectObject)(await (0, core_1.parseJsonBody)(output.body, context));
    contents.configuration = de_AutoTestConfiguration(data, context);
    return contents;
};
exports.de_GetAutoTestConfigurationCommand = de_GetAutoTestConfigurationCommand;
const de_GetAutoTestPublishedSnapshotCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = (0, smithy_client_1.map)({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectObject)(await (0, core_1.parseJsonBody)(output.body, context));
    contents.snapshot = de_AutoTestPublishedSnapshot(data, context);
    return contents;
};
exports.de_GetAutoTestPublishedSnapshotCommand = de_GetAutoTestPublishedSnapshotCommand;
const de_GetAutoTestSnapshotCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = (0, smithy_client_1.map)({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectObject)(await (0, core_1.parseJsonBody)(output.body, context));
    contents.snapshot = de_AutoTestSnapshot(data, context);
    return contents;
};
exports.de_GetAutoTestSnapshotCommand = de_GetAutoTestSnapshotCommand;
const de_ListAutoTestSnapshotsCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = (0, smithy_client_1.map)({
        $metadata: deserializeMetadata(output),
        [_nT]: [, output.headers[_xnt]],
    });
    const data = (0, smithy_client_1.expectNonNull)(((0, smithy_client_1.expectObject)(await (0, core_1.parseJsonBody)(output.body, context))), "body");
    const doc = (0, smithy_client_1.take)(data, {
        'snapshots': _ => de_AutoTestSnapshotSummaries(_, context),
    });
    Object.assign(contents, doc);
    return contents;
};
exports.de_ListAutoTestSnapshotsCommand = de_ListAutoTestSnapshotsCommand;
const de_PutAutoTestConfigurationCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = (0, smithy_client_1.map)({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectObject)(await (0, core_1.parseJsonBody)(output.body, context));
    contents.configuration = de_AutoTestConfiguration(data, context);
    return contents;
};
exports.de_PutAutoTestConfigurationCommand = de_PutAutoTestConfigurationCommand;
const de_UpdateAutoTestConfigurationCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = (0, smithy_client_1.map)({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectObject)(await (0, core_1.parseJsonBody)(output.body, context));
    contents.configuration = de_AutoTestConfiguration(data, context);
    return contents;
};
exports.de_UpdateAutoTestConfigurationCommand = de_UpdateAutoTestConfigurationCommand;
const de_CreateEditorSessionCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = (0, smithy_client_1.map)({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectObject)(await (0, core_1.parseJsonBody)(output.body, context));
    contents.editorSession = de_EditorSession(data, context);
    return contents;
};
exports.de_CreateEditorSessionCommand = de_CreateEditorSessionCommand;
const de_ExecuteEditorDocumentJupyterCellCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = (0, smithy_client_1.map)({
        $metadata: deserializeMetadata(output),
    });
    await (0, smithy_client_1.collectBody)(output.body, context);
    return contents;
};
exports.de_ExecuteEditorDocumentJupyterCellCommand = de_ExecuteEditorDocumentJupyterCellCommand;
const de_GetEditorDocumentCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = (0, smithy_client_1.map)({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectObject)(await (0, core_1.parseJsonBody)(output.body, context));
    contents.document = (0, smithy_client_1._json)(data);
    return contents;
};
exports.de_GetEditorDocumentCommand = de_GetEditorDocumentCommand;
const de_GetEditorFileDownloadLinkCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = (0, smithy_client_1.map)({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectNonNull)(((0, smithy_client_1.expectObject)(await (0, core_1.parseJsonBody)(output.body, context))), "body");
    const doc = (0, smithy_client_1.take)(data, {
        'contentType': smithy_client_1.expectString,
        'filename': smithy_client_1.expectString,
        'url': smithy_client_1.expectString,
    });
    Object.assign(contents, doc);
    return contents;
};
exports.de_GetEditorFileDownloadLinkCommand = de_GetEditorFileDownloadLinkCommand;
const de_GetEditorSessionCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = (0, smithy_client_1.map)({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectObject)(await (0, core_1.parseJsonBody)(output.body, context));
    contents.editorSession = de_EditorSession(data, context);
    return contents;
};
exports.de_GetEditorSessionCommand = de_GetEditorSessionCommand;
const de_HandInEditorSessionCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = (0, smithy_client_1.map)({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectNonNull)(((0, smithy_client_1.expectObject)(await (0, core_1.parseJsonBody)(output.body, context))), "body");
    const doc = (0, smithy_client_1.take)(data, {
        'editorSubmission': smithy_client_1._json,
    });
    Object.assign(contents, doc);
    return contents;
};
exports.de_HandInEditorSessionCommand = de_HandInEditorSessionCommand;
const de_InterruptEditorDocumentJupyterKernelCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = (0, smithy_client_1.map)({
        $metadata: deserializeMetadata(output),
    });
    await (0, smithy_client_1.collectBody)(output.body, context);
    return contents;
};
exports.de_InterruptEditorDocumentJupyterKernelCommand = de_InterruptEditorDocumentJupyterKernelCommand;
const de_ListEditorDocumentJupyterCellOutputsCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = (0, smithy_client_1.map)({
        $metadata: deserializeMetadata(output),
        [_nT]: [, output.headers[_xnt]],
    });
    const data = (0, smithy_client_1.expectNonNull)(((0, smithy_client_1.expectObject)(await (0, core_1.parseJsonBody)(output.body, context))), "body");
    const doc = (0, smithy_client_1.take)(data, {
        'outputs': _ => de_JupyterOutputs(_, context),
    });
    Object.assign(contents, doc);
    return contents;
};
exports.de_ListEditorDocumentJupyterCellOutputsCommand = de_ListEditorDocumentJupyterCellOutputsCommand;
const de_ListEditorDocumentsCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = (0, smithy_client_1.map)({
        $metadata: deserializeMetadata(output),
        [_nT]: [, output.headers[_xnt]],
    });
    const data = (0, smithy_client_1.expectNonNull)(((0, smithy_client_1.expectObject)(await (0, core_1.parseJsonBody)(output.body, context))), "body");
    const doc = (0, smithy_client_1.take)(data, {
        'documents': smithy_client_1._json,
    });
    Object.assign(contents, doc);
    return contents;
};
exports.de_ListEditorDocumentsCommand = de_ListEditorDocumentsCommand;
const de_ListEditorSessionsCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = (0, smithy_client_1.map)({
        $metadata: deserializeMetadata(output),
        [_nT]: [, output.headers[_xnt]],
    });
    const data = (0, smithy_client_1.expectNonNull)(((0, smithy_client_1.expectObject)(await (0, core_1.parseJsonBody)(output.body, context))), "body");
    const doc = (0, smithy_client_1.take)(data, {
        'editorSessions': _ => de_EditorSessions(_, context),
    });
    Object.assign(contents, doc);
    return contents;
};
exports.de_ListEditorSessionsCommand = de_ListEditorSessionsCommand;
const de_PutEditorFileCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = (0, smithy_client_1.map)({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectObject)(await (0, core_1.parseJsonBody)(output.body, context));
    contents.file = de_OutputEditorFile(data, context);
    return contents;
};
exports.de_PutEditorFileCommand = de_PutEditorFileCommand;
const de_GetPearsonContextTemplateCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = (0, smithy_client_1.map)({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectObject)(await (0, core_1.parseJsonBody)(output.body, context));
    contents.contextTemplate = (0, smithy_client_1._json)(data);
    return contents;
};
exports.de_GetPearsonContextTemplateCommand = de_GetPearsonContextTemplateCommand;
const de_GetPearsonContextTemplateQuestionCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = (0, smithy_client_1.map)({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectObject)(await (0, core_1.parseJsonBody)(output.body, context));
    contents.question = de_PearsonContextTemplateQuestion(data, context);
    return contents;
};
exports.de_GetPearsonContextTemplateQuestionCommand = de_GetPearsonContextTemplateQuestionCommand;
const de_InstantiatePearsonTemplateCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = (0, smithy_client_1.map)({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectNonNull)(((0, smithy_client_1.expectObject)(await (0, core_1.parseJsonBody)(output.body, context))), "body");
    const doc = (0, smithy_client_1.take)(data, {
        'rubricRowLock': smithy_client_1.expectString,
    });
    Object.assign(contents, doc);
    return contents;
};
exports.de_InstantiatePearsonTemplateCommand = de_InstantiatePearsonTemplateCommand;
const de_PutPearsonBookCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = (0, smithy_client_1.map)({
        $metadata: deserializeMetadata(output),
    });
    await (0, smithy_client_1.collectBody)(output.body, context);
    return contents;
};
exports.de_PutPearsonBookCommand = de_PutPearsonBookCommand;
const de_PutPearsonContextTemplateCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = (0, smithy_client_1.map)({
        $metadata: deserializeMetadata(output),
    });
    await (0, smithy_client_1.collectBody)(output.body, context);
    return contents;
};
exports.de_PutPearsonContextTemplateCommand = de_PutPearsonContextTemplateCommand;
const de_PutPearsonQuestionCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = (0, smithy_client_1.map)({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectNonNull)(((0, smithy_client_1.expectObject)(await (0, core_1.parseJsonBody)(output.body, context))), "body");
    const doc = (0, smithy_client_1.take)(data, {
        'questionId': smithy_client_1.expectString,
    });
    Object.assign(contents, doc);
    return contents;
};
exports.de_PutPearsonQuestionCommand = de_PutPearsonQuestionCommand;
const de_PutPearsonTemplateCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = (0, smithy_client_1.map)({
        $metadata: deserializeMetadata(output),
    });
    await (0, smithy_client_1.collectBody)(output.body, context);
    return contents;
};
exports.de_PutPearsonTemplateCommand = de_PutPearsonTemplateCommand;
const de_UpdatePearsonContextTemplateCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = (0, smithy_client_1.map)({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectObject)(await (0, core_1.parseJsonBody)(output.body, context));
    contents.contextTemplate = (0, smithy_client_1._json)(data);
    return contents;
};
exports.de_UpdatePearsonContextTemplateCommand = de_UpdatePearsonContextTemplateCommand;
const de_UpdatePearsonContextTemplateQuestionCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = (0, smithy_client_1.map)({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectObject)(await (0, core_1.parseJsonBody)(output.body, context));
    contents.question = de_PearsonContextTemplateQuestion(data, context);
    return contents;
};
exports.de_UpdatePearsonContextTemplateQuestionCommand = de_UpdatePearsonContextTemplateQuestionCommand;
const de_CreateSafeProgramCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = (0, smithy_client_1.map)({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectObject)(await (0, core_1.parseJsonBody)(output.body, context));
    contents.safeProgram = (0, smithy_client_1._json)(data);
    return contents;
};
exports.de_CreateSafeProgramCommand = de_CreateSafeProgramCommand;
const de_CommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await (0, core_1.parseJsonErrorBody)(output.body, context)
    };
    const errorCode = (0, core_1.loadRestJsonErrorCode)(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestError":
        case "com.codegrade.errors#BadRequestError":
            throw await de_BadRequestErrorRes(parsedOutput, context);
        case "InternalServerError":
        case "com.codegrade.errors#InternalServerError":
            throw await de_InternalServerErrorRes(parsedOutput, context);
        case "NotAuthenticatedError":
        case "com.codegrade.errors#NotAuthenticatedError":
            throw await de_NotAuthenticatedErrorRes(parsedOutput, context);
        case "NotAuthorizedError":
        case "com.codegrade.errors#NotAuthorizedError":
            throw await de_NotAuthorizedErrorRes(parsedOutput, context);
        case "NotFoundError":
        case "com.codegrade.errors#NotFoundError":
            throw await de_NotFoundErrorRes(parsedOutput, context);
        case "ValidationError":
        case "com.codegrade.errors#ValidationError":
            throw await de_ValidationErrorRes(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            return throwDefaultError({
                output,
                parsedBody,
                errorCode
            });
    }
};
const throwDefaultError = (0, smithy_client_1.withBaseException)(Apiv2ServiceException_1.Apiv2ServiceException);
const de_BadRequestErrorRes = async (parsedOutput, context) => {
    const contents = (0, smithy_client_1.map)({
        [_rI]: [, parsedOutput.headers[_xri]],
    });
    const data = parsedOutput.body;
    const doc = (0, smithy_client_1.take)(data, {
        'description': smithy_client_1.expectString,
        'message': smithy_client_1.expectString,
        'reason': _ => de_BadRequestErrorReason((0, core_1.awsExpectUnion)(_), context),
    });
    Object.assign(contents, doc);
    const exception = new models_0_1.BadRequestError({
        $metadata: deserializeMetadata(parsedOutput),
        ...contents
    });
    return (0, smithy_client_1.decorateServiceException)(exception, parsedOutput.body);
};
const de_InternalServerErrorRes = async (parsedOutput, context) => {
    const contents = (0, smithy_client_1.map)({
        [_rI]: [, parsedOutput.headers[_xri]],
    });
    const data = parsedOutput.body;
    const doc = (0, smithy_client_1.take)(data, {
        'description': smithy_client_1.expectString,
        'message': smithy_client_1.expectString,
    });
    Object.assign(contents, doc);
    const exception = new models_0_1.InternalServerError({
        $metadata: deserializeMetadata(parsedOutput),
        ...contents
    });
    return (0, smithy_client_1.decorateServiceException)(exception, parsedOutput.body);
};
const de_NotAuthenticatedErrorRes = async (parsedOutput, context) => {
    const contents = (0, smithy_client_1.map)({
        [_rI]: [, parsedOutput.headers[_xri]],
    });
    const data = parsedOutput.body;
    const doc = (0, smithy_client_1.take)(data, {
        'description': smithy_client_1.expectString,
        'message': smithy_client_1.expectString,
    });
    Object.assign(contents, doc);
    const exception = new models_0_1.NotAuthenticatedError({
        $metadata: deserializeMetadata(parsedOutput),
        ...contents
    });
    return (0, smithy_client_1.decorateServiceException)(exception, parsedOutput.body);
};
const de_NotAuthorizedErrorRes = async (parsedOutput, context) => {
    const contents = (0, smithy_client_1.map)({
        [_rI]: [, parsedOutput.headers[_xri]],
    });
    const data = parsedOutput.body;
    const doc = (0, smithy_client_1.take)(data, {
        'description': smithy_client_1.expectString,
        'message': smithy_client_1.expectString,
        'operation': smithy_client_1.expectString,
        'resource': smithy_client_1.expectString,
    });
    Object.assign(contents, doc);
    const exception = new models_0_1.NotAuthorizedError({
        $metadata: deserializeMetadata(parsedOutput),
        ...contents
    });
    return (0, smithy_client_1.decorateServiceException)(exception, parsedOutput.body);
};
const de_NotFoundErrorRes = async (parsedOutput, context) => {
    const contents = (0, smithy_client_1.map)({
        [_rI]: [, parsedOutput.headers[_xri]],
    });
    const data = parsedOutput.body;
    const doc = (0, smithy_client_1.take)(data, {
        'description': smithy_client_1.expectString,
        'message': smithy_client_1.expectString,
        'resource': smithy_client_1.expectString,
    });
    Object.assign(contents, doc);
    const exception = new models_0_1.NotFoundError({
        $metadata: deserializeMetadata(parsedOutput),
        ...contents
    });
    return (0, smithy_client_1.decorateServiceException)(exception, parsedOutput.body);
};
const de_ValidationErrorRes = async (parsedOutput, context) => {
    const contents = (0, smithy_client_1.map)({
        [_rI]: [, parsedOutput.headers[_xri]],
    });
    const data = parsedOutput.body;
    const doc = (0, smithy_client_1.take)(data, {
        'description': smithy_client_1.expectString,
        'fieldList': smithy_client_1._json,
        'message': smithy_client_1.expectString,
    });
    Object.assign(contents, doc);
    const exception = new models_0_1.ValidationError({
        $metadata: deserializeMetadata(parsedOutput),
        ...contents
    });
    return (0, smithy_client_1.decorateServiceException)(exception, parsedOutput.body);
};
const se_AutoTestAllowInternetStepInput = (input, context) => {
    return (0, smithy_client_1.take)(input, {
        'children': _ => se_AutoTestTestStepsInput(_, context),
        'id': [],
    });
};
const se_AutoTestCodeStructureTestStepInput = (input, context) => {
    return (0, smithy_client_1.take)(input, {
        'children': _ => se_AutoTestTestStepsInput(_, context),
        'file': [],
        'id': [],
        'name': [],
        'version': [],
    });
};
const se_AutoTestCodingQuestionStepInput = (input, context) => {
    return (0, smithy_client_1.take)(input, {
        'children': _ => se_AutoTestTestStepsInput(_, context),
        'id': [],
        'name': [],
        'question': [],
        'solution': [],
        'starterCode': [],
        'studentFileName': [],
    });
};
const se_AutoTestConnectRubricStepInput = (input, context) => {
    return (0, smithy_client_1.take)(input, {
        'children': _ => se_AutoTestTestStepsInput(_, context),
        'id': [],
        'rubricRowId': [],
    });
};
const se_AutoTestIoTestStepInput = (input, context) => {
    return (0, smithy_client_1.take)(input, {
        'children': _ => se_AutoTestTestStepsInput(_, context),
        'id': [],
        'name': [],
        'script': [],
    });
};
const se_AutoTestJupyterNotebookStepInput = (input, context) => {
    return (0, smithy_client_1.take)(input, {
        'children': _ => se_AutoTestTestStepsInput(_, context),
        'id': [],
        'kernel': [],
        'name': [],
        'python3KernelVersion': [],
        'runPermission': [],
        'templateFile': _ => se_AutoTestUploadedFileInput(_, context),
    });
};
const se_AutoTestPromptEngineeringQuestionStepInput = (input, context) => {
    return (0, smithy_client_1.take)(input, {
        'answerFilename': [],
        'answerLanguage': [],
        'children': _ => se_AutoTestTestStepsInput(_, context),
        'id': [],
        'name': [],
        'question': [],
        'systemPrompt': [],
    });
};
const se_AutoTestQuizStepInput = (input, context) => {
    return (0, smithy_client_1.take)(input, {
        'children': _ => se_AutoTestTestStepsInput(_, context),
        'fileName': [],
        'id': [],
        'runSingleQuestions': [],
        'viewMode': [],
    });
};
const se_AutoTestRunIfStepInput = (input, context) => {
    return (0, smithy_client_1.take)(input, {
        'children': _ => se_AutoTestTestStepsInput(_, context),
        'condition': smithy_client_1._json,
        'id': [],
    });
};
const se_AutoTestRunInStepInput = (input, context) => {
    return (0, smithy_client_1.take)(input, {
        'children': _ => se_AutoTestTestStepsInput(_, context),
        'environment': [],
        'id': [],
    });
};
const se_AutoTestSetupConfigurationInput = (input, context) => {
    return (0, smithy_client_1.take)(input, {
        'steps': _ => se_AutoTestSetupStepsInput(_, context),
    });
};
const se_AutoTestSetupStepInput = (input, context) => {
    return models_0_1.AutoTestSetupStepInput.visit(input, {
        installClang: value => ({ "installClang": (0, smithy_client_1._json)(value) }),
        installDotnet: value => ({ "installDotnet": (0, smithy_client_1._json)(value) }),
        installGcc: value => ({ "installGcc": (0, smithy_client_1._json)(value) }),
        installJava: value => ({ "installJava": (0, smithy_client_1._json)(value) }),
        installNode: value => ({ "installNode": (0, smithy_client_1._json)(value) }),
        installPython: value => ({ "installPython": (0, smithy_client_1._json)(value) }),
        script: value => ({ "script": (0, smithy_client_1._json)(value) }),
        uploadFiles: value => ({ "uploadFiles": se_AutoTestUploadFilesStepInput(value, context) }),
        _: (name, value) => ({ [name]: value })
    });
};
const se_AutoTestSetupStepsInput = (input, context) => {
    return input.filter((e) => e != null).map(entry => {
        return se_AutoTestSetupStepInput(entry, context);
    });
};
const se_AutoTestSnapshotStepInput = (input, context) => {
    return (0, smithy_client_1.take)(input, {
        'children': _ => se_AutoTestTestStepsInput(_, context),
        'id': [],
    });
};
const se_AutoTestTestConfigurationInput = (input, context) => {
    return (0, smithy_client_1.take)(input, {
        'steps': _ => se_AutoTestTestStepsInput(_, context),
    });
};
const se_AutoTestTestHideStepInput = (input, context) => {
    return (0, smithy_client_1.take)(input, {
        'children': _ => se_AutoTestTestStepsInput(_, context),
        'hideType': [],
        'id': [],
        'preposition': [],
        'when': [],
    });
};
const se_AutoTestTestStepInput = (input, context) => {
    return models_1_1.AutoTestTestStepInput.visit(input, {
        allowInternet: value => ({ "allowInternet": se_AutoTestAllowInternetStepInput(value, context) }),
        checkstyle: value => ({ "checkstyle": (0, smithy_client_1._json)(value) }),
        codeStructureTest: value => ({ "codeStructureTest": se_AutoTestCodeStructureTestStepInput(value, context) }),
        codingQuestion: value => ({ "codingQuestion": se_AutoTestCodingQuestionStepInput(value, context) }),
        connectRubric: value => ({ "connectRubric": se_AutoTestConnectRubricStepInput(value, context) }),
        customTest: value => ({ "customTest": (0, smithy_client_1._json)(value) }),
        flake8: value => ({ "flake8": (0, smithy_client_1._json)(value) }),
        ioTest: value => ({ "ioTest": se_AutoTestIoTestStepInput(value, context) }),
        javaCompile: value => ({ "javaCompile": (0, smithy_client_1._json)(value) }),
        junit5: value => ({ "junit5": (0, smithy_client_1._json)(value) }),
        jupyterNotebook: value => ({ "jupyterNotebook": se_AutoTestJupyterNotebookStepInput(value, context) }),
        mcq: value => ({ "mcq": (0, smithy_client_1._json)(value) }),
        negativeMatch: value => ({ "negativeMatch": (0, smithy_client_1._json)(value) }),
        output: value => ({ "output": (0, smithy_client_1._json)(value) }),
        positiveMatch: value => ({ "positiveMatch": (0, smithy_client_1._json)(value) }),
        program: value => ({ "program": (0, smithy_client_1._json)(value) }),
        promptEngineeringQuestion: value => ({ "promptEngineeringQuestion": se_AutoTestPromptEngineeringQuestionStepInput(value, context) }),
        pytest: value => ({ "pytest": (0, smithy_client_1._json)(value) }),
        quiz: value => ({ "quiz": se_AutoTestQuizStepInput(value, context) }),
        regexMatch: value => ({ "regexMatch": (0, smithy_client_1._json)(value) }),
        runIf: value => ({ "runIf": se_AutoTestRunIfStepInput(value, context) }),
        runIn: value => ({ "runIn": se_AutoTestRunInStepInput(value, context) }),
        runInNotebook: value => ({ "runInNotebook": (0, smithy_client_1._json)(value) }),
        selectAllQuestion: value => ({ "selectAllQuestion": (0, smithy_client_1._json)(value) }),
        simpleMatch: value => ({ "simpleMatch": (0, smithy_client_1._json)(value) }),
        simplePythonTest: value => ({ "simplePythonTest": (0, smithy_client_1._json)(value) }),
        snapshot: value => ({ "snapshot": se_AutoTestSnapshotStepInput(value, context) }),
        substringMatch: value => ({ "substringMatch": (0, smithy_client_1._json)(value) }),
        testHide: value => ({ "testHide": se_AutoTestTestHideStepInput(value, context) }),
        testTimeoutEach: value => ({ "testTimeoutEach": se_AutoTestTestTimeoutEachStepInput(value, context) }),
        testUploadFiles: value => ({ "testUploadFiles": se_AutoTestTestUploadFilesStepInput(value, context) }),
        weight: value => ({ "weight": se_AutoTestWeightStepInput(value, context) }),
        _: (name, value) => ({ [name]: value })
    });
};
const se_AutoTestTestStepsInput = (input, context) => {
    return input.filter((e) => e != null).map(entry => {
        return se_AutoTestTestStepInput(entry, context);
    });
};
const se_AutoTestTestTimeoutEachStepInput = (input, context) => {
    return (0, smithy_client_1.take)(input, {
        'children': _ => se_AutoTestTestStepsInput(_, context),
        'id': [],
        'timeout': [],
    });
};
const se_AutoTestTestUploadFilesStepInput = (input, context) => {
    return (0, smithy_client_1.take)(input, {
        'description': smithy_client_1._json,
        'files': _ => se_AutoTestUploadedFilesInput(_, context),
        'id': [],
        'name': [],
    });
};
const se_AutoTestUploadedFileInput = (input, context) => {
    return (0, smithy_client_1.take)(input, {
        'contents': context.base64Encoder,
        'id': [],
        'path': [],
    });
};
const se_AutoTestUploadedFilesInput = (input, context) => {
    return input.filter((e) => e != null).map(entry => {
        return se_AutoTestUploadedFileInput(entry, context);
    });
};
const se_AutoTestUploadFilesStepInput = (input, context) => {
    return (0, smithy_client_1.take)(input, {
        'description': smithy_client_1._json,
        'files': _ => se_AutoTestUploadedFilesInput(_, context),
        'id': [],
        'name': [],
    });
};
const se_AutoTestWeightStepInput = (input, context) => {
    return (0, smithy_client_1.take)(input, {
        'children': _ => se_AutoTestTestStepsInput(_, context),
        'id': [],
        'weight': smithy_client_1._json,
    });
};
const de_AssistantConversation = (output, context) => {
    return (0, smithy_client_1.take)(output, {
        'assistantId': smithy_client_1.expectString,
        'conversationId': smithy_client_1.expectString,
        'createdAt': (_) => (0, smithy_client_1.expectNonNull)((0, smithy_client_1.parseRfc3339DateTimeWithOffset)(_)),
        'owner': smithy_client_1.expectString,
        'title': smithy_client_1.expectString,
    });
};
const de_AssistantConversations = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        return de_AssistantConversation(entry, context);
    });
    return retVal;
};
const de_AssistantMessage = (output, context) => {
    return (0, smithy_client_1.take)(output, {
        'assistantId': smithy_client_1.expectString,
        'conversationId': smithy_client_1.expectString,
        'createdAt': (_) => (0, smithy_client_1.expectNonNull)((0, smithy_client_1.parseRfc3339DateTimeWithOffset)(_)),
        'data': (_) => de_AssistantMessageData((0, core_1.awsExpectUnion)(_), context),
        'messageId': smithy_client_1.expectString,
    });
};
const de_AssistantMessageData = (output, context) => {
    if (output.assistant != null) {
        return {
            assistant: (0, smithy_client_1._json)(output.assistant)
        };
    }
    if (output.user != null) {
        return {
            user: de_AssistantMessageUserData(output.user, context)
        };
    }
    return { $unknown: Object.entries(output)[0] };
};
const de_AssistantMessages = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        return de_AssistantMessage(entry, context);
    });
    return retVal;
};
const de_AssistantMessageUserData = (output, context) => {
    return (0, smithy_client_1.take)(output, {
        'author': (_) => de_User((0, core_1.awsExpectUnion)(_), context),
        'content': (_) => (0, smithy_client_1._json)((0, core_1.awsExpectUnion)(_)),
    });
};
const de_AutoTestAllowInternetStepOutput = (output, context) => {
    return (0, smithy_client_1.take)(output, {
        'children': (_) => de_AutoTestTestStepsOutput(_, context),
        'id': smithy_client_1.expectString,
    });
};
const de_AutoTestCodeStructureTestStepOutput = (output, context) => {
    return (0, smithy_client_1.take)(output, {
        'children': (_) => de_AutoTestTestStepsOutput(_, context),
        'file': smithy_client_1.expectString,
        'id': smithy_client_1.expectString,
        'name': smithy_client_1.expectString,
        'version': smithy_client_1.expectString,
    });
};
const de_AutoTestCodingQuestionStepOutput = (output, context) => {
    return (0, smithy_client_1.take)(output, {
        'children': (_) => de_AutoTestTestStepsOutput(_, context),
        'id': smithy_client_1.expectString,
        'name': smithy_client_1.expectString,
        'question': smithy_client_1.expectString,
        'solution': smithy_client_1.expectString,
        'starterCode': smithy_client_1.expectString,
        'studentFileName': smithy_client_1.expectString,
    });
};
const de_AutoTestConfiguration = (output, context) => {
    return (0, smithy_client_1.take)(output, {
        'assignmentId': smithy_client_1.expectString,
        'publishedSnapshot': (_) => (0, smithy_client_1._json)((0, core_1.awsExpectUnion)(_)),
        'setup': smithy_client_1._json,
        'test': (_) => de_AutoTestTestConfigurationOutput(_, context),
    });
};
const de_AutoTestConnectRubricStepOutput = (output, context) => {
    return (0, smithy_client_1.take)(output, {
        'children': (_) => de_AutoTestTestStepsOutput(_, context),
        'id': smithy_client_1.expectString,
        'rubricRowId': smithy_client_1.expectInt32,
    });
};
const de_AutoTestIoTestStepOutput = (output, context) => {
    return (0, smithy_client_1.take)(output, {
        'children': (_) => de_AutoTestTestStepsOutput(_, context),
        'id': smithy_client_1.expectString,
        'name': smithy_client_1.expectString,
        'script': smithy_client_1.expectString,
    });
};
const de_AutoTestJupyterNotebookStepOutput = (output, context) => {
    return (0, smithy_client_1.take)(output, {
        'children': (_) => de_AutoTestTestStepsOutput(_, context),
        'id': smithy_client_1.expectString,
        'kernel': smithy_client_1.expectString,
        'name': smithy_client_1.expectString,
        'python3KernelVersion': smithy_client_1.expectString,
        'runPermission': smithy_client_1.expectString,
        'templateFile': smithy_client_1._json,
    });
};
const de_AutoTestPromptEngineeringQuestionStepOutput = (output, context) => {
    return (0, smithy_client_1.take)(output, {
        'answerFilename': smithy_client_1.expectString,
        'answerLanguage': smithy_client_1.expectString,
        'children': (_) => de_AutoTestTestStepsOutput(_, context),
        'id': smithy_client_1.expectString,
        'name': smithy_client_1.expectString,
        'question': smithy_client_1.expectString,
        'systemPrompt': smithy_client_1.expectString,
    });
};
const de_AutoTestPublishedSnapshot = (output, context) => {
    return (0, smithy_client_1.take)(output, {
        'assignmentId': smithy_client_1.expectString,
        'createdAt': (_) => (0, smithy_client_1.expectNonNull)((0, smithy_client_1.parseRfc3339DateTimeWithOffset)(_)),
        'snapshotId': smithy_client_1.expectString,
        'test': (_) => de_AutoTestRedactedTestConfigurationOutput(_, context),
    });
};
const de_AutoTestQuizStepOutput = (output, context) => {
    return (0, smithy_client_1.take)(output, {
        'children': (_) => de_AutoTestTestStepsOutput(_, context),
        'fileName': smithy_client_1.expectString,
        'id': smithy_client_1.expectString,
        'runSingleQuestions': smithy_client_1.expectBoolean,
        'viewMode': smithy_client_1.expectString,
    });
};
const de_AutoTestRedactedAllowInternetStepOutput = (output, context) => {
    return (0, smithy_client_1.take)(output, {
        'children': (_) => de_AutoTestRedactedTestStepsOutput(_, context),
        'id': smithy_client_1.expectString,
    });
};
const de_AutoTestRedactedCodeStructureTestStepOutput = (output, context) => {
    return (0, smithy_client_1.take)(output, {
        'children': (_) => de_AutoTestRedactedTestStepsOutput(_, context),
        'file': (_) => (0, smithy_client_1._json)((0, core_1.awsExpectUnion)(_)),
        'id': smithy_client_1.expectString,
        'name': smithy_client_1.expectString,
        'version': (_) => (0, smithy_client_1._json)((0, core_1.awsExpectUnion)(_)),
    });
};
const de_AutoTestRedactedCodingQuestionStepOutput = (output, context) => {
    return (0, smithy_client_1.take)(output, {
        'children': (_) => de_AutoTestRedactedTestStepsOutput(_, context),
        'id': smithy_client_1.expectString,
        'name': smithy_client_1.expectString,
        'question': smithy_client_1.expectString,
        'solution': (_) => (0, smithy_client_1._json)((0, core_1.awsExpectUnion)(_)),
        'starterCode': smithy_client_1.expectString,
        'studentFileName': smithy_client_1.expectString,
    });
};
const de_AutoTestRedactedConnectRubricStepOutput = (output, context) => {
    return (0, smithy_client_1.take)(output, {
        'children': (_) => de_AutoTestRedactedTestStepsOutput(_, context),
        'id': smithy_client_1.expectString,
        'rubricRowId': (_) => (0, smithy_client_1._json)((0, core_1.awsExpectUnion)(_)),
    });
};
const de_AutoTestRedactedIoTestStepOutput = (output, context) => {
    return (0, smithy_client_1.take)(output, {
        'children': (_) => de_AutoTestRedactedTestStepsOutput(_, context),
        'id': smithy_client_1.expectString,
        'name': smithy_client_1.expectString,
        'script': (_) => (0, smithy_client_1._json)((0, core_1.awsExpectUnion)(_)),
    });
};
const de_AutoTestRedactedJupyterNotebookStepOutput = (output, context) => {
    return (0, smithy_client_1.take)(output, {
        'children': (_) => de_AutoTestRedactedTestStepsOutput(_, context),
        'id': smithy_client_1.expectString,
        'kernel': smithy_client_1.expectString,
        'name': smithy_client_1.expectString,
        'python3KernelVersion': smithy_client_1.expectString,
        'runPermission': smithy_client_1.expectString,
        'templateFile': smithy_client_1._json,
    });
};
const de_AutoTestRedactedPromptEngineeringQuestionStepOutput = (output, context) => {
    return (0, smithy_client_1.take)(output, {
        'answerFilename': smithy_client_1.expectString,
        'answerLanguage': smithy_client_1.expectString,
        'children': (_) => de_AutoTestRedactedTestStepsOutput(_, context),
        'id': smithy_client_1.expectString,
        'name': smithy_client_1.expectString,
        'question': smithy_client_1.expectString,
        'systemPrompt': smithy_client_1.expectString,
    });
};
const de_AutoTestRedactedQuizStepOutput = (output, context) => {
    return (0, smithy_client_1.take)(output, {
        'children': (_) => de_AutoTestRedactedTestStepsOutput(_, context),
        'fileName': smithy_client_1.expectString,
        'id': smithy_client_1.expectString,
        'runSingleQuestions': smithy_client_1.expectBoolean,
        'viewMode': smithy_client_1.expectString,
    });
};
const de_AutoTestRedactedRunIfStepOutput = (output, context) => {
    return (0, smithy_client_1.take)(output, {
        'children': (_) => de_AutoTestRedactedTestStepsOutput(_, context),
        'condition': (_) => (0, smithy_client_1._json)((0, core_1.awsExpectUnion)(_)),
        'id': smithy_client_1.expectString,
    });
};
const de_AutoTestRedactedRunInStepOutput = (output, context) => {
    return (0, smithy_client_1.take)(output, {
        'children': (_) => de_AutoTestRedactedTestStepsOutput(_, context),
        'environment': smithy_client_1.expectString,
        'id': smithy_client_1.expectString,
    });
};
const de_AutoTestRedactedSnapshotStepOutput = (output, context) => {
    return (0, smithy_client_1.take)(output, {
        'children': (_) => de_AutoTestRedactedTestStepsOutput(_, context),
        'id': smithy_client_1.expectString,
    });
};
const de_AutoTestRedactedTestConfigurationOutput = (output, context) => {
    return (0, smithy_client_1.take)(output, {
        'steps': (_) => de_AutoTestRedactedTestStepsOutput(_, context),
    });
};
const de_AutoTestRedactedTestHideStepOutput = (output, context) => {
    return (0, smithy_client_1.take)(output, {
        'children': (_) => de_AutoTestRedactedTestStepsOutput(_, context),
        'hideType': smithy_client_1.expectString,
        'id': smithy_client_1.expectString,
        'preposition': smithy_client_1.expectString,
        'when': smithy_client_1.expectString,
    });
};
const de_AutoTestRedactedTestStepOutput = (output, context) => {
    if (output.allowInternet != null) {
        return {
            allowInternet: de_AutoTestRedactedAllowInternetStepOutput(output.allowInternet, context)
        };
    }
    if (output.checkstyle != null) {
        return {
            checkstyle: (0, smithy_client_1._json)(output.checkstyle)
        };
    }
    if (output.codeStructureTest != null) {
        return {
            codeStructureTest: de_AutoTestRedactedCodeStructureTestStepOutput(output.codeStructureTest, context)
        };
    }
    if (output.codingQuestion != null) {
        return {
            codingQuestion: de_AutoTestRedactedCodingQuestionStepOutput(output.codingQuestion, context)
        };
    }
    if (output.connectRubric != null) {
        return {
            connectRubric: de_AutoTestRedactedConnectRubricStepOutput(output.connectRubric, context)
        };
    }
    if (output.customTest != null) {
        return {
            customTest: (0, smithy_client_1._json)(output.customTest)
        };
    }
    if (output.flake8 != null) {
        return {
            flake8: (0, smithy_client_1._json)(output.flake8)
        };
    }
    if (output.ioTest != null) {
        return {
            ioTest: de_AutoTestRedactedIoTestStepOutput(output.ioTest, context)
        };
    }
    if (output.javaCompile != null) {
        return {
            javaCompile: (0, smithy_client_1._json)(output.javaCompile)
        };
    }
    if (output.junit5 != null) {
        return {
            junit5: (0, smithy_client_1._json)(output.junit5)
        };
    }
    if (output.jupyterNotebook != null) {
        return {
            jupyterNotebook: de_AutoTestRedactedJupyterNotebookStepOutput(output.jupyterNotebook, context)
        };
    }
    if (output.mcq != null) {
        return {
            mcq: (0, smithy_client_1._json)(output.mcq)
        };
    }
    if (output.negativeMatch != null) {
        return {
            negativeMatch: (0, smithy_client_1._json)(output.negativeMatch)
        };
    }
    if (output.output != null) {
        return {
            output: (0, smithy_client_1._json)(output.output)
        };
    }
    if (output.positiveMatch != null) {
        return {
            positiveMatch: (0, smithy_client_1._json)(output.positiveMatch)
        };
    }
    if (output.program != null) {
        return {
            program: (0, smithy_client_1._json)(output.program)
        };
    }
    if (output.promptEngineeringQuestion != null) {
        return {
            promptEngineeringQuestion: de_AutoTestRedactedPromptEngineeringQuestionStepOutput(output.promptEngineeringQuestion, context)
        };
    }
    if (output.pytest != null) {
        return {
            pytest: (0, smithy_client_1._json)(output.pytest)
        };
    }
    if (output.quiz != null) {
        return {
            quiz: de_AutoTestRedactedQuizStepOutput(output.quiz, context)
        };
    }
    if (output.regexMatch != null) {
        return {
            regexMatch: (0, smithy_client_1._json)(output.regexMatch)
        };
    }
    if (output.runIf != null) {
        return {
            runIf: de_AutoTestRedactedRunIfStepOutput(output.runIf, context)
        };
    }
    if (output.runIn != null) {
        return {
            runIn: de_AutoTestRedactedRunInStepOutput(output.runIn, context)
        };
    }
    if (output.runInNotebook != null) {
        return {
            runInNotebook: (0, smithy_client_1._json)(output.runInNotebook)
        };
    }
    if (output.selectAllQuestion != null) {
        return {
            selectAllQuestion: (0, smithy_client_1._json)(output.selectAllQuestion)
        };
    }
    if (output.simpleMatch != null) {
        return {
            simpleMatch: (0, smithy_client_1._json)(output.simpleMatch)
        };
    }
    if (output.simplePythonTest != null) {
        return {
            simplePythonTest: (0, smithy_client_1._json)(output.simplePythonTest)
        };
    }
    if (output.snapshot != null) {
        return {
            snapshot: de_AutoTestRedactedSnapshotStepOutput(output.snapshot, context)
        };
    }
    if (output.substringMatch != null) {
        return {
            substringMatch: (0, smithy_client_1._json)(output.substringMatch)
        };
    }
    if (output.testHide != null) {
        return {
            testHide: de_AutoTestRedactedTestHideStepOutput(output.testHide, context)
        };
    }
    if (output.testTimeoutEach != null) {
        return {
            testTimeoutEach: de_AutoTestRedactedTestTimeoutEachStepOutput(output.testTimeoutEach, context)
        };
    }
    if (output.testUploadFiles != null) {
        return {
            testUploadFiles: (0, smithy_client_1._json)(output.testUploadFiles)
        };
    }
    if (output.weight != null) {
        return {
            weight: de_AutoTestRedactedWeightStepOutput(output.weight, context)
        };
    }
    return { $unknown: Object.entries(output)[0] };
};
const de_AutoTestRedactedTestStepsOutput = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        return de_AutoTestRedactedTestStepOutput((0, core_1.awsExpectUnion)(entry), context);
    });
    return retVal;
};
const de_AutoTestRedactedTestTimeoutEachStepOutput = (output, context) => {
    return (0, smithy_client_1.take)(output, {
        'children': (_) => de_AutoTestRedactedTestStepsOutput(_, context),
        'id': smithy_client_1.expectString,
        'timeout': (_) => (0, smithy_client_1._json)((0, core_1.awsExpectUnion)(_)),
    });
};
const de_AutoTestRedactedWeightStepOutput = (output, context) => {
    return (0, smithy_client_1.take)(output, {
        'children': (_) => de_AutoTestRedactedTestStepsOutput(_, context),
        'id': smithy_client_1.expectString,
        'weight': (_) => (0, smithy_client_1._json)((0, core_1.awsExpectUnion)(_)),
    });
};
const de_AutoTestRunIfStepOutput = (output, context) => {
    return (0, smithy_client_1.take)(output, {
        'children': (_) => de_AutoTestTestStepsOutput(_, context),
        'condition': smithy_client_1._json,
        'id': smithy_client_1.expectString,
    });
};
const de_AutoTestRunInStepOutput = (output, context) => {
    return (0, smithy_client_1.take)(output, {
        'children': (_) => de_AutoTestTestStepsOutput(_, context),
        'environment': smithy_client_1.expectString,
        'id': smithy_client_1.expectString,
    });
};
const de_AutoTestSnapshot = (output, context) => {
    return (0, smithy_client_1.take)(output, {
        'assignmentId': smithy_client_1.expectString,
        'autoInstall': smithy_client_1._json,
        'createdAt': (_) => (0, smithy_client_1.expectNonNull)((0, smithy_client_1.parseRfc3339DateTimeWithOffset)(_)),
        'setup': smithy_client_1._json,
        'snapshotId': smithy_client_1.expectString,
        'source': (_) => (0, smithy_client_1._json)((0, core_1.awsExpectUnion)(_)),
        'test': (_) => de_AutoTestTestConfigurationOutput(_, context),
    });
};
const de_AutoTestSnapshotStepOutput = (output, context) => {
    return (0, smithy_client_1.take)(output, {
        'children': (_) => de_AutoTestTestStepsOutput(_, context),
        'id': smithy_client_1.expectString,
    });
};
const de_AutoTestSnapshotSummaries = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        return de_AutoTestSnapshotSummary(entry, context);
    });
    return retVal;
};
const de_AutoTestSnapshotSummary = (output, context) => {
    return (0, smithy_client_1.take)(output, {
        'assignmentId': smithy_client_1.expectString,
        'createdAt': (_) => (0, smithy_client_1.expectNonNull)((0, smithy_client_1.parseRfc3339DateTimeWithOffset)(_)),
        'snapshotId': smithy_client_1.expectString,
        'source': (_) => (0, smithy_client_1._json)((0, core_1.awsExpectUnion)(_)),
    });
};
const de_AutoTestTestConfigurationOutput = (output, context) => {
    return (0, smithy_client_1.take)(output, {
        'steps': (_) => de_AutoTestTestStepsOutput(_, context),
    });
};
const de_AutoTestTestHideStepOutput = (output, context) => {
    return (0, smithy_client_1.take)(output, {
        'children': (_) => de_AutoTestTestStepsOutput(_, context),
        'hideType': smithy_client_1.expectString,
        'id': smithy_client_1.expectString,
        'preposition': smithy_client_1.expectString,
        'when': smithy_client_1.expectString,
    });
};
const de_AutoTestTestStepOutput = (output, context) => {
    if (output.allowInternet != null) {
        return {
            allowInternet: de_AutoTestAllowInternetStepOutput(output.allowInternet, context)
        };
    }
    if (output.checkstyle != null) {
        return {
            checkstyle: (0, smithy_client_1._json)(output.checkstyle)
        };
    }
    if (output.codeStructureTest != null) {
        return {
            codeStructureTest: de_AutoTestCodeStructureTestStepOutput(output.codeStructureTest, context)
        };
    }
    if (output.codingQuestion != null) {
        return {
            codingQuestion: de_AutoTestCodingQuestionStepOutput(output.codingQuestion, context)
        };
    }
    if (output.connectRubric != null) {
        return {
            connectRubric: de_AutoTestConnectRubricStepOutput(output.connectRubric, context)
        };
    }
    if (output.customTest != null) {
        return {
            customTest: (0, smithy_client_1._json)(output.customTest)
        };
    }
    if (output.flake8 != null) {
        return {
            flake8: (0, smithy_client_1._json)(output.flake8)
        };
    }
    if (output.ioTest != null) {
        return {
            ioTest: de_AutoTestIoTestStepOutput(output.ioTest, context)
        };
    }
    if (output.javaCompile != null) {
        return {
            javaCompile: (0, smithy_client_1._json)(output.javaCompile)
        };
    }
    if (output.junit5 != null) {
        return {
            junit5: (0, smithy_client_1._json)(output.junit5)
        };
    }
    if (output.jupyterNotebook != null) {
        return {
            jupyterNotebook: de_AutoTestJupyterNotebookStepOutput(output.jupyterNotebook, context)
        };
    }
    if (output.mcq != null) {
        return {
            mcq: (0, smithy_client_1._json)(output.mcq)
        };
    }
    if (output.negativeMatch != null) {
        return {
            negativeMatch: (0, smithy_client_1._json)(output.negativeMatch)
        };
    }
    if (output.output != null) {
        return {
            output: (0, smithy_client_1._json)(output.output)
        };
    }
    if (output.positiveMatch != null) {
        return {
            positiveMatch: (0, smithy_client_1._json)(output.positiveMatch)
        };
    }
    if (output.program != null) {
        return {
            program: (0, smithy_client_1._json)(output.program)
        };
    }
    if (output.promptEngineeringQuestion != null) {
        return {
            promptEngineeringQuestion: de_AutoTestPromptEngineeringQuestionStepOutput(output.promptEngineeringQuestion, context)
        };
    }
    if (output.pytest != null) {
        return {
            pytest: (0, smithy_client_1._json)(output.pytest)
        };
    }
    if (output.quiz != null) {
        return {
            quiz: de_AutoTestQuizStepOutput(output.quiz, context)
        };
    }
    if (output.regexMatch != null) {
        return {
            regexMatch: (0, smithy_client_1._json)(output.regexMatch)
        };
    }
    if (output.runIf != null) {
        return {
            runIf: de_AutoTestRunIfStepOutput(output.runIf, context)
        };
    }
    if (output.runIn != null) {
        return {
            runIn: de_AutoTestRunInStepOutput(output.runIn, context)
        };
    }
    if (output.runInNotebook != null) {
        return {
            runInNotebook: (0, smithy_client_1._json)(output.runInNotebook)
        };
    }
    if (output.selectAllQuestion != null) {
        return {
            selectAllQuestion: (0, smithy_client_1._json)(output.selectAllQuestion)
        };
    }
    if (output.simpleMatch != null) {
        return {
            simpleMatch: (0, smithy_client_1._json)(output.simpleMatch)
        };
    }
    if (output.simplePythonTest != null) {
        return {
            simplePythonTest: (0, smithy_client_1._json)(output.simplePythonTest)
        };
    }
    if (output.snapshot != null) {
        return {
            snapshot: de_AutoTestSnapshotStepOutput(output.snapshot, context)
        };
    }
    if (output.substringMatch != null) {
        return {
            substringMatch: (0, smithy_client_1._json)(output.substringMatch)
        };
    }
    if (output.testHide != null) {
        return {
            testHide: de_AutoTestTestHideStepOutput(output.testHide, context)
        };
    }
    if (output.testTimeoutEach != null) {
        return {
            testTimeoutEach: de_AutoTestTestTimeoutEachStepOutput(output.testTimeoutEach, context)
        };
    }
    if (output.testUploadFiles != null) {
        return {
            testUploadFiles: (0, smithy_client_1._json)(output.testUploadFiles)
        };
    }
    if (output.weight != null) {
        return {
            weight: de_AutoTestWeightStepOutput(output.weight, context)
        };
    }
    return { $unknown: Object.entries(output)[0] };
};
const de_AutoTestTestStepsOutput = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        return de_AutoTestTestStepOutput((0, core_1.awsExpectUnion)(entry), context);
    });
    return retVal;
};
const de_AutoTestTestTimeoutEachStepOutput = (output, context) => {
    return (0, smithy_client_1.take)(output, {
        'children': (_) => de_AutoTestTestStepsOutput(_, context),
        'id': smithy_client_1.expectString,
        'timeout': smithy_client_1.expectInt32,
    });
};
const de_AutoTestWeightStepOutput = (output, context) => {
    return (0, smithy_client_1.take)(output, {
        'children': (_) => de_AutoTestTestStepsOutput(_, context),
        'id': smithy_client_1.expectString,
        'weight': smithy_client_1._json,
    });
};
const de_Group = (output, context) => {
    return (0, smithy_client_1.take)(output, {
        'createdAt': (_) => (0, smithy_client_1.expectNonNull)((0, smithy_client_1.parseRfc3339DateTimeWithOffset)(_)),
        'groupSetId': smithy_client_1.expectString,
        'id': smithy_client_1.expectString,
        'members': smithy_client_1._json,
        'name': smithy_client_1.expectString,
    });
};
const de_GroupUser = (output, context) => {
    return (0, smithy_client_1.take)(output, {
        'group': (_) => de_Group(_, context),
        'id': smithy_client_1.expectString,
        'tenantId': smithy_client_1.expectString,
        'username': smithy_client_1.expectString,
    });
};
const de_User = (output, context) => {
    if (output.group != null) {
        return {
            group: de_GroupUser(output.group, context)
        };
    }
    if (output.normal != null) {
        return {
            normal: (0, smithy_client_1._json)(output.normal)
        };
    }
    return { $unknown: Object.entries(output)[0] };
};
const de_EditorFileList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        return de_EditorFileType((0, core_1.awsExpectUnion)(entry), context);
    });
    return retVal;
};
const de_EditorFileType = (output, context) => {
    if (output.directory != null) {
        return {
            directory: de_OutputEditorDirectoryType(output.directory, context)
        };
    }
    if (output.regular != null) {
        return {
            regular: (0, smithy_client_1._json)((0, core_1.awsExpectUnion)(output.regular))
        };
    }
    return { $unknown: Object.entries(output)[0] };
};
const de_EditorSession = (output, context) => {
    return (0, smithy_client_1.take)(output, {
        'assignmentId': smithy_client_1.expectString,
        'createdAt': (_) => (0, smithy_client_1.expectNonNull)((0, smithy_client_1.parseRfc3339DateTimeWithOffset)(_)),
        'editorSessionId': smithy_client_1.expectString,
        'fileTreeId': smithy_client_1.expectString,
        'name': smithy_client_1.expectString,
        'owner': smithy_client_1.expectString,
        'updatedAt': (_) => (0, smithy_client_1.expectNonNull)((0, smithy_client_1.parseRfc3339DateTimeWithOffset)(_)),
    });
};
const de_EditorSessions = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        return de_EditorSession(entry, context);
    });
    return retVal;
};
const de_JupyterDisplayDataOutputEvent = (output, context) => {
    return (0, smithy_client_1.take)(output, {
        'displayId': smithy_client_1.expectString,
        'kernelId': smithy_client_1.expectString,
        'mimeData': (_) => de_JupyterMimeOutputDataEvent(_, context),
    });
};
const de_JupyterExecuteResultOutputEvent = (output, context) => {
    return (0, smithy_client_1.take)(output, {
        'executionCount': smithy_client_1.expectInt32,
        'kernelId': smithy_client_1.expectString,
        'mimeData': (_) => de_JupyterMimeOutputDataEvent(_, context),
    });
};
const de_JupyterMimeOutputDataEvent = (output, context) => {
    return Object.entries(output).reduce((acc, [key, value]) => {
        if (value === null) {
            return acc;
        }
        acc[key] = de_JupyterMimeOutputDataEventValue((0, core_1.awsExpectUnion)(value), context);
        return acc;
    }, {});
};
const de_JupyterMimeOutputDataEventValue = (output, context) => {
    if (output.inline != null) {
        return {
            inline: context.base64Decoder(output.inline)
        };
    }
    if (output.link != null) {
        return {
            link: (0, smithy_client_1._json)(output.link)
        };
    }
    return { $unknown: Object.entries(output)[0] };
};
const de_JupyterOutput = (output, context) => {
    return (0, smithy_client_1.take)(output, {
        'event': (_) => de_JupyterOutputEvent((0, core_1.awsExpectUnion)(_), context),
        'jupyterOutputId': smithy_client_1.expectString,
    });
};
const de_JupyterOutputEvent = (output, context) => {
    if (output.displayData != null) {
        return {
            displayData: de_JupyterDisplayDataOutputEvent(output.displayData, context)
        };
    }
    if (output.error != null) {
        return {
            error: (0, smithy_client_1._json)(output.error)
        };
    }
    if (output.executeInterrupted != null) {
        return {
            executeInterrupted: (0, smithy_client_1._json)(output.executeInterrupted)
        };
    }
    if (output.executeRequested != null) {
        return {
            executeRequested: (0, smithy_client_1._json)(output.executeRequested)
        };
    }
    if (output.executeResult != null) {
        return {
            executeResult: de_JupyterExecuteResultOutputEvent(output.executeResult, context)
        };
    }
    if (output.executeStart != null) {
        return {
            executeStart: (0, smithy_client_1._json)(output.executeStart)
        };
    }
    if (output.stream != null) {
        return {
            stream: de_JupyterStreamOutputEvent(output.stream, context)
        };
    }
    return { $unknown: Object.entries(output)[0] };
};
const de_JupyterOutputs = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        return de_JupyterOutput(entry, context);
    });
    return retVal;
};
const de_JupyterStreamOutputEvent = (output, context) => {
    return (0, smithy_client_1.take)(output, {
        'kernelId': smithy_client_1.expectString,
        'name': smithy_client_1.expectString,
        'value': (_) => de_JupyterStreamOutputEventValue((0, core_1.awsExpectUnion)(_), context),
    });
};
const de_JupyterStreamOutputEventValue = (output, context) => {
    if (output.inline != null) {
        return {
            inline: context.base64Decoder(output.inline)
        };
    }
    if (output.link != null) {
        return {
            link: (0, smithy_client_1._json)(output.link)
        };
    }
    return { $unknown: Object.entries(output)[0] };
};
const de_OutputEditorDirectoryType = (output, context) => {
    return (0, smithy_client_1.take)(output, {
        'children': (_) => de_EditorFileList(_, context),
    });
};
const de_OutputEditorFile = (output, context) => {
    return (0, smithy_client_1.take)(output, {
        'assignmentId': smithy_client_1.expectString,
        'editorSessionId': smithy_client_1.expectString,
        'fileType': (_) => de_EditorFileType((0, core_1.awsExpectUnion)(_), context),
        'path': smithy_client_1.expectString,
    });
};
const de_BadRequestErrorReason = (output, context) => {
    if (output.ignoreNonInteractedQuestions != null) {
        return {
            ignoreNonInteractedQuestions: (0, smithy_client_1._json)(output.ignoreNonInteractedQuestions)
        };
    }
    if (output.inexplicitRubricOverwrite != null) {
        return {
            inexplicitRubricOverwrite: (0, smithy_client_1._json)(output.inexplicitRubricOverwrite)
        };
    }
    if (output.invalidParam != null) {
        return {
            invalidParam: de_InvalidParamErrorReason(output.invalidParam, context)
        };
    }
    if (output.invalidState != null) {
        return {
            invalidState: (0, smithy_client_1._json)(output.invalidState)
        };
    }
    if (output.unknownEnumType != null) {
        return {
            unknownEnumType: de_UnknownEnumTypeErrorReason(output.unknownEnumType, context)
        };
    }
    if (output.wrongItemCount != null) {
        return {
            wrongItemCount: de_WrongItemCountErrorReason(output.wrongItemCount, context)
        };
    }
    return { $unknown: Object.entries(output)[0] };
};
const de_FoundUnknownEnumType = (output, context) => {
    return (0, smithy_client_1.take)(output, {
        'type': smithy_client_1.expectString,
        'value': (_) => de_Document(_, context),
    });
};
const de_InvalidParamErrorReason = (output, context) => {
    return (0, smithy_client_1.take)(output, {
        'error': smithy_client_1.expectString,
        'name': smithy_client_1.expectString,
        'value': (_) => de_Document(_, context),
    });
};
const de_UnknownEnumTypeErrorReason = (output, context) => {
    return (0, smithy_client_1.take)(output, {
        'found': (_) => de_FoundUnknownEnumType(_, context),
    });
};
const de_WrongItemCountErrorReason = (output, context) => {
    return (0, smithy_client_1.take)(output, {
        'found': (_) => de_DocumentList(_, context),
        'maximumAllowed': smithy_client_1.expectInt32,
        'minimumAllowed': smithy_client_1.expectInt32,
        'what': smithy_client_1.expectString,
    });
};
const de_PearsonCodingQuestionData = (output, context) => {
    return (0, smithy_client_1.take)(output, {
        'autoTestSteps': (_) => de_Document(_, context),
        'correctAnswer': smithy_client_1.expectString,
        'description': smithy_client_1.expectString,
        'filename': smithy_client_1.expectString,
        'template': smithy_client_1.expectString,
        'viewCorrectAnswer': smithy_client_1.expectBoolean,
    });
};
const de_PearsonContextTemplateQuestion = (output, context) => {
    return (0, smithy_client_1.take)(output, {
        'data': (_) => de_PearsonQuestionData((0, core_1.awsExpectUnion)(_), context),
        'enabled': smithy_client_1.expectBoolean,
        'name': smithy_client_1.expectString,
        'questionId': smithy_client_1.expectString,
    });
};
const de_PearsonQuestionData = (output, context) => {
    if (output.coding != null) {
        return {
            coding: de_PearsonCodingQuestionData(output.coding, context)
        };
    }
    if (output.multipleChoice != null) {
        return {
            multipleChoice: (0, smithy_client_1._json)(output.multipleChoice)
        };
    }
    if (output.selectAll != null) {
        return {
            selectAll: (0, smithy_client_1._json)(output.selectAll)
        };
    }
    return { $unknown: Object.entries(output)[0] };
};
const de_DocumentList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        return de_Document(entry, context);
    });
    return retVal;
};
const de_Document = (output, context) => {
    return output;
};
const deserializeMetadata = (output) => ({
    httpStatusCode: output.statusCode,
    requestId: output.headers["x-amzn-requestid"] ?? output.headers["x-amzn-request-id"] ?? output.headers["x-amz-request-id"],
    extendedRequestId: output.headers["x-amz-id-2"],
    cfId: output.headers["x-amz-cf-id"],
});
const collectBodyString = (streamBody, context) => (0, smithy_client_1.collectBody)(streamBody, context).then(body => context.utf8Encoder(body));
const _aI = "assignmentId";
const _nT = "nextToken";
const _p = "path";
const _pS = "pageSize";
const _rI = "requestId";
const _xnt = "x-next-token";
const _xps = "x-page-size";
const _xri = "x-request-id";
